/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const usePesoEnvase = (id_cultivo) => {
  const token = localStorage.getItem("@Token");
  const [pesoEnvase, setPesoEnvase] = useState([]);

  const getPesoEnvase = useCallback(async () => {
    try {
      const response = await api.get(`api/etiquetas/peso_envase/`, {
        params: { id_cultivo },
        headers: {
          Authorization: "Token " + token,
        },
      });
      setPesoEnvase(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [id_cultivo]);

  useEffect(() => {
    getPesoEnvase();
  }, [getPesoEnvase]);

  return { pesoEnvase, getPesoEnvase };
};
